"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importStar(require("react"));
const Dialog = __importStar(require("@radix-ui/react-dialog"));
const Button_1 = require("../Button");
const Modal_styles_1 = require("./Modal.styles");
const ModalRoot = react_1.default.forwardRef((_a, forwardedRef) => {
    var { open, onOpenChange, onOpenAutoFocus, onCloseAutoFocus, dismissible = true, size = "medium", fullscreen, container = document.body, children } = _a, props = __rest(_a, ["open", "onOpenChange", "onOpenAutoFocus", "onCloseAutoFocus", "dismissible", "size", "fullscreen", "container", "children"]);
    const [trigger, setTrigger] = (0, react_1.useState)(null);
    /**
     * Identify and remember the trigger element manually so it can be
     * focused on when closing the modal.
     */
    (0, react_1.useEffect)(() => {
        if (!onCloseAutoFocus &&
            open &&
            document.activeElement instanceof HTMLElement) {
            setTrigger(document.activeElement);
        }
    }, [onCloseAutoFocus, open]);
    const handleCloseAutoFocus = (e) => {
        if (onCloseAutoFocus) {
            onCloseAutoFocus(e);
        }
        else {
            trigger === null || trigger === void 0 ? void 0 : trigger.focus();
        }
    };
    const handleInteractOutside = (e) => {
        if (!dismissible) {
            e.preventDefault();
        }
    };
    return (react_1.default.createElement(Dialog.Root, { open: open, onOpenChange: onOpenChange },
        react_1.default.createElement(Dialog.Portal, { container: container },
            react_1.default.createElement(Modal_styles_1.StyledModalOverlay, null,
                react_1.default.createElement(Modal_styles_1.StyledModalContent, Object.assign({ ref: forwardedRef, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: handleCloseAutoFocus, onInteractOutside: handleInteractOutside, "aria-describedby": undefined, "aria-modal": true, "$size": size, "$fullscreen": fullscreen }, props), children)))));
});
const ModalTitle = react_1.default.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Modal_styles_1.StyledModalTitle, Object.assign({ ref: forwardedRef }, props), children));
});
const ModalSection = react_1.default.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Modal_styles_1.StyledModalSection, Object.assign({ ref: forwardedRef }, props), children));
});
const CloseButton = react_1.default.forwardRef((_a, forwardedRef) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(Dialog.Close, { asChild: true },
        react_1.default.createElement(Modal_styles_1.StyledCloseButton, Object.assign({ ref: forwardedRef, type: "button", appearance: "tertiary", "aria-label": "Close the modal" }, props),
            react_1.default.createElement(Button_1.Button.Icon, { name: "Cross" }))));
});
const Modal = Object.assign(ModalRoot, {
    Title: ModalTitle,
    Section: ModalSection,
    CloseButton: CloseButton,
    Divider: Modal_styles_1.StyledHr,
});
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map